import {
  TALLY_FIELDS,
  TALLY_FIELD_LABELS,
  type ReconcilerTally,
} from "./reconciler_tallies";

/** Per-reconciler counters, shared by the live run panel and the run detail sheet. */
export function ReconcilerTallyTable({
  tallies,
}: {
  tallies: ReconcilerTally[];
}) {
  if (tallies.length === 0) return null;

  return (
    <div className="border-border overflow-x-auto rounded-md border">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-border bg-muted border-b">
            <th className="text-muted-foreground px-3 py-2 text-left text-xs font-medium">
              Reconciler
            </th>
            {TALLY_FIELDS.map((field) => (
              <th
                key={field}
                className="text-muted-foreground px-3 py-2 text-right text-xs font-medium"
              >
                {/* eslint-disable-next-line security/detect-object-injection -- field is a member of the TALLY_FIELDS const array */}
                {TALLY_FIELD_LABELS[field]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tallies.map((tally) => (
            <tr key={tally.name} className="border-border border-t">
              <td className="text-foreground px-3 py-2 font-mono text-xs">
                {tally.name}
              </td>
              {TALLY_FIELDS.map((field) => {
                // eslint-disable-next-line security/detect-object-injection -- field is a member of the TALLY_FIELDS const array
                const value = tally[field];
                const bad =
                  (field === "errors" || field === "unprocessed") && value > 0;
                return (
                  <td
                    key={field}
                    className={`px-3 py-2 text-right tabular-nums ${
                      bad ? "font-semibold text-red-600" : "text-foreground"
                    }`}
                  >
                    {value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
